import React, { Component, createContext } from 'react';
import { getDropdownList } from '../data/countries';

export const StoreContext = createContext('');

export const list = getDropdownList();

const platforms = [
  {
    id: 'android',
    title: 'Google Play Store®'
  },
  {
    id: 'ios',
    title: 'Apple App Store®'
  },
]

class StoreDropdown extends Component {
  static contextType = StoreContext;
  constructor(props) {
    super(props);
    this.state = {
    listOpen: false,
    };
    this.componentRef = React.createRef();
  }

  componentDidMount() {
    window.addEventListener('click', this.clickOutside);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickOutside);
  }

  close = () => {
    this.setState({
      listOpen: false
    });
  }

  clickOutside = (event) => {
    if (this.componentRef && !this.componentRef.contains(event.target)) {
      this.close();
    }
  }

  setWrapperRef = (node) => {
    this.componentRef = node;
  }

  clearDropdown = (evt) => {
    evt.stopPropagation();
    this.context.update('');
    this.context.updateURL('');
  }

  selectItem(radioId, evt) {
    evt.stopPropagation();
    const url = this.getStoreURL(radioId);
    this.context.update(radioId);
    this.context.updateURL(url);
    this.close();
  }

  getURL(country) {
    if (this.isIOS()) {
      return country.iosURL;
    }
    if (this.isAndroid()) {
      return country.androidURL;
    }
  }

  goToStore(event) {
    const url = event.target.value;
    window.location.assign(url);
  }

  getStoreURL(radioId) {
    const [country, platform] = radioId.split('-'); 
    return list.find(({ id }) => id === country)[`${platform}URL`]
  }

  openList = () => {
    this.setState( {listOpen: true});
  }

  getRadioId = (id, platform) => {
    return `${id}-${platform}`;
  }

  /**
   * Renders the HTML for the 2 stores input radios (AppStore & Play Store)
   */
  renderPlatformFactory = item => platform => (
    <label key={platform.id} className="radio-btn">
      <input type="radio" name="store" readOnly onClick={(evt) => this.selectItem(this.getRadioId(item.id, platform.id), evt)} checked={this.getRadioId(item.id, platform.id) === this.context.value}></input>
      <span className="title">{platform.title}</span>
      <div className="checkmark"></div>
    </label>
  )

  renderSinglePlatform(item, platform) {
    return (<label key={platform.id} className="radio-btn only-countries">
      <input type="radio" name="store" readOnly onClick={(evt) => this.selectItem(this.getRadioId(item.id, platform.id), evt)} checked={this.getRadioId(item.id, platform.id) === this.context.value}></input>
      <span className="title only-countries">{item.title}</span>
      <div className="checkmark"></div>
    </label>);
  }

  isIOS() {
    const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
    return iosPlatforms.indexOf(window.navigator.platform) !== -1
  }

  isAndroid() {
    return (/Android/).test(window.navigator.userAgent);
  }

  /**
   * Renders the HTML code for the country list items (group of the 2 platforms)
   */
  renderCountry = (item, showRegion) => {
    const renderPlatform = this.renderPlatformFactory(item);
    let content = [];
    if (this.isIOS()) {
      content.push(this.renderSinglePlatform(item, platforms[1]));
    } else if (this.isAndroid()) {
      content.push(this.renderSinglePlatform(item, platforms[0]));
    } else {
      content.push(
        <p key="0" className="country-name">{item.title}</p>,
        <span key="1">{platforms.map(renderPlatform)}</span>
      );
    }
    return (
      <li key={item.id}>
        {
          showRegion && <p className="region-name">{item.region}</p>
        }
        {content}
      </li>
    )
  }

  /**
   * Renders the closed dropdown selection
   */
  renderLabel = () => {
    if (this.context.value.length === 0) {
      return <span>Select your app store country</span>
    }
    const [country, platform] = this.context.value.split('-');
    return <div className="platform-wrapper">
      <div className="platform-info">
        <span className="selected-item-title">{list.find(({ id }) => id === country).title}</span>
        <span className="selected-item-platform">{platforms.find(({ id }) => id === platform).title}</span>
      </div>
      <span className="close-icon" readOnly onClick={(evt) => this.clearDropdown(evt)} ></span>
    </div>;
  }

  renderList() {
    let prevRegion = '';
    let showRegion = false;
    return list.map((country) => {
      if (prevRegion !== country.region) {
        showRegion = true;
        prevRegion = country.region;
      } else {
        showRegion = false;
      }

      return this.renderCountry(country, showRegion);
    })
  }

  render() {
    const { listOpen } = this.state;

    return (
      <>
        <div className={`hide-mobile dropdown ${this.context.value.length === 0 ? '' : 'selected'}`} onClick={this.openList} ref={this.setWrapperRef}>
        {this.renderLabel()}

        {listOpen && (
          <div className="dropdown-list">
            <div className="dropdown-list-wrapper">
              <ul>
                {
                  this.renderList()
                 }
              </ul>
            </div>
          </div>
        )}
      </div>

        <div className="dropdown language-dropdown hide-tablets-desktop">
          <select className="mobile-select" onChange={this.goToStore}>
            <option>Select your app store country</option>
            {
              list.map(country => <option key={country.id} value={this.getURL(country)}>{country.title}</option>)
            }
          </select>
      </div>
      </>
    )
  }
}

export default StoreDropdown;
